import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BaseMediaClientError } from '../../models/errors';
export var MediaStoreError = /*#__PURE__*/function (_BaseMediaClientError) {
  function MediaStoreError(reason, innerError) {
    _classCallCheck(this, MediaStoreError);
    return _callSuper(this, MediaStoreError, [reason, undefined, innerError]);
  }

  // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
  /** Will be deprecated. Use the properties `reason` and `metadata` instead */
  _inherits(MediaStoreError, _BaseMediaClientError);
  return _createClass(MediaStoreError, [{
    key: "attributes",
    get: function get() {
      var reason = this.reason,
        innerError = this.innerError;
      return {
        reason: reason,
        innerError: innerError
      };
    }
  }]);
}(BaseMediaClientError);
export function isMediaStoreError(err) {
  return err instanceof MediaStoreError;
}